<template>
  <!-- 路由编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="图书ID: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="12">
            <el-input
              v-model="detailId"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="图书分类: "
          prop="clazz"
          :label-width="formLabelWidth"
        >
          <el-col :span="17">
            <el-radio-group v-model="form.clazz" :disabled="isView">
              <el-radio :label="'1'">汉语辞书</el-radio>
              <el-radio :label="'2'">外语辞书</el-radio>
              <el-radio :label="'3'">民族语辞书</el-radio>
              <el-radio :label="'6'">专科辞书</el-radio>
              <el-radio :label="'7'">百科辞书</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>

        <el-form-item label="置顶顺序: " prop="sort" :label-width="formLabelWidth">
          <el-col :span="12">
            <el-input
              v-model="form.sort"
              :disabled="isView"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="4"
              autocomplete="off"
              placeholder="请输入置顶顺序,数值小的在最上面,最小值为1,默认9999"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="图书名称: "
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-col :span="12">
            <el-input
              v-model="form.name"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              show-word-limit
              placeholder="请输入图书名称"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="图书封面:"
          class="div-upload-form-item address"
          :label-width="formLabelWidth"
        >
          <div class="div-upload-container" ref="uploadBottom">
            <el-upload
              ref="uploadImg"
              accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
              list-type="picture-card"
              action=""
              multiple
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :before-upload="handleBefore"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议比例: W: H=3:4  建议尺寸:W*H=180*250 (px)</div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="图书视频:" :label-width="formLabelWidth">
          <el-col :span="6">
          <el-upload
            ref="uploadVideo"
            class="avatar-uploader"
            :action="videoAction"
            :headers="headers"
            accept=".mp4"
            :data="paramsdata"
            :show-file-list="false"
            :before-upload="beforeUploadVideo"
            :on-success="handleVideoSuccess"
            :on-progress="uploadVideoProcess"
          >

            <video
              v-if="form.videoUrl1 != '' && videoFlag == false"
              :src="form.videoUrl1"
              width="350"
              height="180"
              controls="controls"
              controlslist="nodownload noremoteplayback"
            >
              您的浏览器不支持视频播放
            </video>
            <el-button
              v-else-if="form.videoUrl1 =='' && videoFlag == false"
              type="primary"
            >上传视频</el-button>
            <el-progress
              v-if="videoFlag == true"
              type="circle"
              :percentage="videoUploadPercent"
              style="margin-top: 30px"
            ></el-progress>

          </el-upload>
          </el-col>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="出版社:"
              prop="publisher"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.publisher"
                :disabled="isView"
                :maxlength="maxlength"
                placeholder="请输入"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="定 价:"
              prop="price"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.price"
                :disabled="isView"
                placeholder="请输入"
                autocomplete="off"
              >
              <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="作 者:"
              prop="author"
              :label-width="formLabelWidth"
            >
              <el-input
                :maxlength="maxlength"
                :disabled="isView"
                v-model="form.author"
                placeholder="请输入"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="开 本:"
              prop="bookSize"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.bookSize"
                :disabled="isView"
                :maxlength="maxlength"
                placeholder="请输入"
                autocomplete="off"
                >
              >
              <template slot="append">开</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="出版时间:"
              prop="pubDate"
              :label-width="formLabelWidth"
            >
              <el-input
                :maxlength="maxlength"
                :disabled="isView"
                v-model="form.pubDate"
                placeholder="请输入"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="书 号:"
              prop="isbn"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.isbn"
                :disabled="isView"
                :maxlength="maxlength"
                placeholder="请输入"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="图书简介: "
          prop="detail"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              type="textarea"
              :disabled="isView"
              v-model="form.detail"
              autocomplete="off"
              maxlength="5000"
              :rows="3"
              show-word-limit
              placeholder="请输入简介"
            />
          </el-col>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
         <el-button type="primary" v-show="isView" @click="$router.push('/dictionaries-management')">
          返回列表
        </el-button>
        <el-button type="primary" class="confirm-button" :disabled="isView" @click="handelConfirm('form', 0)">
          发 布
        </el-button>
        <el-button class="confirm-button" :disabled="isView" @click="handelConfirm('form', 1)"
          >保 存</el-button
        >
      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Net from '@/constants'
import dictionaryApi from '@/api/dictionaryWorld/index.js'
import { mapRequestActions } from '@/utils'
import { getToken } from '@/utils/auth'
import encryption from '@/utils/encryption.js'
export default {
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      isView: !!this.$route.query.isView || false, // 判断预览
      isRemove: true, // 判断上传图片是否删除
      dialogVisible: false, // 上传预览图片弹窗
      dialogImageUrl: '', // 上传预览图片url
      detailId: this.$route.query.id || '',
      detailList: {},
      maxlength: 200,
      fileList: [],
      sendFile: [],
      imageId: '', // 上传封面ID
      videoId: '', // 图书视频ID
      videoAction: Net.baseUrl + '/common/upload',
      headers: {
        Authorization: 'CsxhBearer ' + getToken()
      },
      form: {
        name: '',
        clazz: '',
        sort: '',
        publisher: '',
        price: '',
        author: '',
        bookSize: '', // 开本
        pubDate: '',
        isbn: '',
        detail: '', // 简介
        videoUrl1: '' // 视频
      },
      videoFlag: false, // 刚开始的时候显示为flase
      videoUploadPercent: '0%', // 进度条刚开始的时候为0%
      paramsdata: {},

      rule: {
        clazz: [
          { required: true, message: '请选择图书分类', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入图书名称', trigger: 'change' }
        ],
        publisher: [
          { required: true, message: '请输入出版社名称', trigger: 'change' }
        ],
        intro: [
          { required: true, message: '请输入图书简介', trigger: 'change' }
        ],
        price: [
          // { required: true, message: '请输入图书定价', trigger: 'change' },
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: '请输入正确的价格' }
        ],
        author: [
          { required: true, message: '请输入作者名称', trigger: 'change' }
        ],
        bookSize: [
          // { required: true, message: '请输入开本', trigger: 'change' }
          { pattern: /^[\u4e00-\u9fa50-9]+$/, message: '请输入正确的开本信息' }
        ],
        // pubDate: [
        //   { required: true, message: '请输入出版时间', trigger: 'change' }
        // ],
        // isbn: [{ required: true, message: '请输入书号', trigger: 'change' }],
        detail: [{ required: true, message: '请输入简介', trigger: 'change' }]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
  },
  methods: {
    ...mapRequestActions(dictionaryApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = Object.assign(this.form, {
            coverFileId: this.imageId,
            status: type,
            clazz: this.form.clazz,
            videoFileId: this.videoId
          })
          // 编辑状态 且 点击发布
          if (this.detailId && type === 0) {
            this.upDateDicBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
                this.$router.push('/dictionaries-management')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.upDateDicBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
                this.$router.push('/dictionaries-management')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else {
            this.addDicBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
                this.$router.push('/dictionaries-management')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
        } else {
          // todo
        }
      })
    },

    /**
     * 根据ID 查询详情
     */
    async handleQueryDetailById () {
      const resultData = await this.queryDetailByIDAction({
        id: this.detailId
      })
      if (resultData.status) {
        this.form = resultData.result || []
        this.form.clazz = resultData.result.clazz + ''
        this.form.videoUrl1 = resultData.result.videoFile ? Net.baseUrl + resultData.result.videoFile.relativePath : ''
        if (resultData.result.coverFileId) {
          this.imageId = resultData.result.coverFileId
        }
        if (resultData.result.coverFile) {
          this.fileList.push({
            name: this.form.name,
            url: Net.baseUrl + resultData.result.coverFile.relativePath || ''
          })
        }
      }
    },

    /**
     * handleRefresh 强制checkbox-group刷新
     */
    handleRefresh () {
      this.$forceUpdate()
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {

      } else {
        const index = this.fileList.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
      }
      this.fileList = []
      this.imageId = ''
    },
    handleChange () {},

    handleBefore (file) {
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach(element => {
          formData.append('file', element)
        })
        formData.append('bizeType', '纸质辞书管理')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId = res.result.id || ''
          }
        })
        image.src = data
      }
      return false
    },

    /**
     * 新建页面 -- 重置按钮
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploadImg.clearFiles()
      this.$refs.uploadVideo.clearFiles()
      this.form.videoUrl1 = ''
      this.form.url = ''
      this.imageId = ''
      this.videoId = ''
      this.fileList = []
    },

    handleExceed () {
      this.$message.warning('最多可以上传1张图片')
    },
    // 上传前限制大小
    beforeUploadVideo (file) {
      const isLt20M = file.size / 1024 / 1024 < 500
      if (['video/mp4'].indexOf(file.type) === -1) {
        this.$message.error('请上传正确的视频格式,仅支持.mp4视频')
        return false
      }
      if (!isLt20M) {
        this.$message.error('上传视频大小不能超过500MB哦!')
        return false
      }
      this.isShowUploadVideo = false
      this.load = true
    },
    handleVideoSuccess (res, file) { // 视频上传成功之后返回视频地址
      const result = JSON.parse(encryption.decrypt('w!c_@y(0^sz-xd=h', res))
      this.videoFlag = false
      this.videoUploadPercent = 0
      this.form.videoUrl1 = Net.baseUrl + result.relativePath
      this.form.url = Net.baseUrl + result.relativePath
      this.videoId = result.id || ''
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      // this.videoFlag = true
      // this.videoUploadPercent = file.percentage.toFixed(0) * 1
      this.videoFlag = true
      this.videoUploadPercent = parseInt(file.percentage)
    }

  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 90%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 10px 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  // .address {
  //   /deep/ .el-form-item__label:before {
  //     content: "*" !important;
  //     color: #f56c6c !important;
  //     margin-right: 4px !important;
  //   }
  // }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 150px;
    float: left;
    text-align: left;
    // overflow: hidden;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
    .el-upload__tip{
      margin-top: 0;
      line-height: 26px;
      padding-bottom: 5px;
    }
  }
}

.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.select_button {
  float: left;
}
.el-col-6 {
  text-align: left;
  padding: 2px 0;
}

/deep/ .input_style {
  display: inline-block;
  padding-left: 4px;
  text-indent: 2px;
  width: 100px;
}

.avatar-uploader i {
    border: 1px dashed #c0ccda;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
.el-col{
  text-align: left;
}

</style>
